import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';
import Logo from 'src/components/Logo';

import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  Typography
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SidebarMenu from './SidebarMenu';
import HeaderUserbox from '../Header/Userbox';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: 280px;
        min-width: 280px;
        color: ${theme.palette.text.primary};
        position: relative;
        z-index: 7;
        height: 100%;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  const sidebarContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <Scrollbar>
          {/* Logo Section */}
          <Box sx={{ px: 4, py: 4, display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Logo />
          </Box>
          
          <SidebarMenu />
        </Scrollbar>
      </Box>

      {/* Bottom Actions */}
      <Box sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
        <HeaderUserbox />
      </Box>
    </Box>
  );

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          bgcolor: 'background.paper',
          borderRight: `1px solid ${theme.palette.divider}`
        }}
      >
        {sidebarContent}
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            bgcolor: 'background.paper'
          }}
        >
          {sidebarContent}
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
